import buitendienstManifest from './buitendienst/manifest.js';
import ixinaDashboardManifest from './ixina-dashboard/manifest.js';
import crmManifest from './crm/manifest.js';
import communicatieManifest from './communicatie/manifest.js';
import offerteManifest from './offerte/manifest.js';
import catalogusManifest from './catalogus/manifest.js';
import marketingManifest from './marketing/manifest.js';
import planningManifest from './planning/manifest.js';
import logistiekManifest from './logistiek/manifest.js';
import serviceManifest from './service/manifest.js';
import onboardingManifest from './onboarding/manifest.js';
import smartbotManifest from './smartbot/manifest.js';
import projectenManifest from './projecten/manifest.js';
import type { ModuleDefinition } from '../core/shared/types/index.js';

export const modules: ModuleDefinition[] = [
  communicatieManifest,
  crmManifest,
  offerteManifest,
  catalogusManifest,
  buitendienstManifest,
  ixinaDashboardManifest,
  marketingManifest,
  planningManifest,
  logistiekManifest,
  serviceManifest,
  smartbotManifest,
  onboardingManifest,
  projectenManifest,
];

export function getActiveModules(): ModuleDefinition[] {
  return modules.filter(m => m.status === 'active');
}
